<H1> Mapped Servo<app-loader [status]="loaderStatus"></app-loader></H1>
<div *ngFor='let in of counter(100) ;let i = index'>
  <div fxLayout="column" fxLayoutGap="32px">
    <app-mappedservodetails [refNumber]="i"></app-mappedservodetails>
  </div>
</div>


